import genererGuid from '@/services/general/genererGuid';
import * as devisConf from '@/configuration/devisConf';
import miseAJourPersonnalise from '@/services/devisCommandes/miseAJourPersonnalise';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import maxOrderBaseGetter from '@/services/devisCommandes/maxOrderBaseGetter';

export default function creationRegroupementPersonnalise(
  lignesCommandesARegrouper, lignesCommande, i18n,
) {
  // Je pars du principe que je ne peux pas croire l'ordre de lignesCommandesAREgrouper
  const listeOrdreARegrouper = lignesCommandesARegrouper.map(l => l.ordre);
  const minOrdre = Math.min(...listeOrdreARegrouper);
  const indexInsertion = lignesCommande.indexOf(lignesCommande.find(l => l.ordre === minOrdre));
  const lignePersonnalisee = genererLigneCommande(
    maxOrderBaseGetter(lignesCommande) + 1,
  );
  const referencePersonnalise = genererGuid();
  // MAJ des lignes du regroupement
  lignesCommande.forEach(ligne => {
    if (listeOrdreARegrouper.includes(ligne.ordre)) {
      ligne.referencePersonnalise = referencePersonnalise;
      if (ligne.type === devisConf.REGROUPEMENT) {
        ligne.lignesCommande.forEach(sousLigne => {
          sousLigne.referencePersonnalise = referencePersonnalise;
        });
      }
    }
  });
  miseAJourPersonnalise(
    lignePersonnalisee,
    i18n,
    referencePersonnalise,
    lignesCommande,
  );
  lignesCommande.splice(indexInsertion, 0, lignePersonnalisee);
}
